/** GELİŞTİRME VERİSİ — gerçek portföy değil, tamamı uydurma. */

import type { NewAccount, NewManualValuation, NewTransaction } from "@parafon/contracts/local-api";
import type { ManualPrice } from "@parafon/contracts/local-api";

const accounts: readonly NewAccount[] = [
  {
    id: "acc-demo-aracikurum",
    name: "Örnek Aracı Kurum",
    kind: "araci_kurum",
    institution: "Örnek Yatırım",
    currency: "TRY",
    openedAt: "2024-01-02",
  },
  { id: "acc-demo-banka", name: "Örnek Banka", kind: "banka", institution: "Örnek Bank", currency: "TRY" },
  { id: "acc-demo-cuzdan", name: "Örnek Kripto Cüzdanı", kind: "cuzdan", currency: "USD" },
];

const transactions: readonly NewTransaction[] = [
  {
    id: "01JDEMO0000000000000000001",
    accountId: "acc-demo-aracikurum",
    asset: { kind: "manual", label: "NAKİT TRY", currency: "TRY" },
    type: "DEPOSIT",
    tradeDate: "2024-01-03",
    quantity: "1",
    price: "50000",
    currency: "TRY",
  },
  {
    id: "01JDEMO0000000000000000002",
    accountId: "acc-demo-aracikurum",
    asset: { kind: "tracked", instrumentId: "BIST:THYAO" },
    type: "BUY",
    tradeDate: "2024-01-10",
    quantity: "100",
    price: "254.75",
    currency: "TRY",
    fee: "12.5",
  },
  {
    id: "01JDEMO0000000000000000003",
    accountId: "acc-demo-aracikurum",
    asset: { kind: "tracked", instrumentId: "BIST:THYAO" },
    type: "SELL",
    tradeDate: "2024-06-14",
    quantity: "40",
    price: "301.2",
    currency: "TRY",
    fee: "8",
    tax: "1.4",
  },
  {
    id: "01JDEMO0000000000000000004",
    accountId: "acc-demo-cuzdan",
    asset: { kind: "tracked", instrumentId: "BINANCE:BTCUSDT" },
    type: "BUY",
    tradeDate: "2024-03-05",
    quantity: "0.0125",
    price: "63120.44",
    currency: "USD",
  },
  {
    id: "01JDEMO0000000000000000005",
    accountId: "acc-demo-banka",
    asset: { kind: "manual", label: "Fiziki gram altın", currency: "TRY" },
    type: "BUY",
    tradeDate: "2024-02-20",
    quantity: "25",
    price: "1985.3",
    currency: "TRY",
  },
  {
    id: "01JDEMO0000000000000000006",
    accountId: "acc-demo-banka",
    asset: { kind: "manual", label: "NAKİT TRY", currency: "TRY" },
    type: "INTEREST",
    tradeDate: "2024-04-01",
    quantity: "1",
    price: "1250.75",
    currency: "TRY",
    tax: "187.61",
  },
];

const manualValuations: readonly NewManualValuation[] = [
  {
    id: "val-demo-1",
    label: "Fiziki gram altın",
    date: "2024-12-31",
    value: "3210.5",
    currency: "TRY",
    note: "Kuyumcu alış fiyatı",
  },
];

/** Tohum verisinin cihaz kimliği — yalnızca geliştirme verisi. */
const SEED_DEVICE_ID = "seed-device";

const manualPrices: readonly ManualPrice[] = [
  {
    instrumentRef: "BIST:THYAO",
    date: "2024-12-31",
    close: "289.4",
    currency: "TRY",
    lamport: 0,
    deviceId: SEED_DEVICE_ID,
    deleted: false,
    updatedAt: "2024-12-31T18:00:00Z",
  },
];

export const DEV_SEED = { accounts, transactions, manualValuations, manualPrices } as const;
